import React, { useEffect, useRef, useState } from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import gsap from "gsap"

const activeCardClass = "hover-card--active"

const HoverCard = ({ blok }) => {
  // All scripts here is for mobile slide down effect. On desktop, style solution is enough.
  const [showHoverMobile, setShowHoverMobile] = useState(false)
  const hoverRef = useRef()
  const cardRef = useRef()
  const mainRef = useRef()

  const onCardClick = () => {
    if (window.innerWidth < 768) {
      setShowHoverMobile(!showHoverMobile)
    }
  }

  const onWindowResize = () => {
    if (
      window.innerWidth < 768 &&
      !cardRef.current.classList.contains(activeCardClass)
    ) {
      hoverRef.current.style.height = `${mainRef.current.offsetHeight}px`
    }
  }

  useEffect(() => {
    if (typeof window == "undefined") {
      return;
    }  

    window.addEventListener("resize", onWindowResize)
    return () => {
      window.removeEventListener("resize", onWindowResize)
    }
  }, [])

  useEffect(() => {
    cardRef.current.classList.toggle(activeCardClass, showHoverMobile)
    if (showHoverMobile) {
      gsap.to(hoverRef.current, {
        duration: 0.2,
        height: "auto",
      })
    } else {
      gsap.to(hoverRef.current, {
        duration: 0.2,
        height: mainRef.current.offsetHeight,
      })
    }
  }, [showHoverMobile])

  return (
    <div
      className="hover-card component"
      {...storyblokEditable(blok)}
      key={blok._uid}
      onClick={onCardClick}
      onKeyDown={onCardClick}
      role="presentation"
      ref={cardRef}
    >
      <div className="hover-card__main" ref={mainRef}>
        {blok.main_content.map(blok => (
          <StoryblokComponent blok={blok} key={blok._uid} />
        ))}
      </div>
      <div className="hover-card__hover" ref={hoverRef}>
        <div className="hover-card__hover-inner">
          {blok.hover_content.map(blok => (
            <StoryblokComponent blok={blok} key={blok._uid} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default HoverCard
